import React, { useEffect, useRef } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';

import { fedops } from '../../fedops';
import invalidPng from '../../assets/images/invalid.png';

import styles from './invalid.scss';

export const Invalid: React.FC = () => {
  const { t } = useTranslation();

  const appLoadedReported = useRef(false);

  useEffect(() => {
    if (!appLoadedReported.current) {
      appLoadedReported.current = true;
      fedops.appLoaded();
    }
  }, []);

  return (
    <div className={styles.invalidMain}>
      <div>
        <img src={invalidPng} alt="" />
      </div>
      <div className={styles.invalidText}>{t('INVALID.MAIN')}</div>
    </div>
  );
};
